import { render, staticRenderFns } from "./ListPaciente.vue?vue&type=template&id=06cf7275&"
import script from "./ListPaciente.vue?vue&type=script&lang=js&"
export * from "./ListPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports